import { Link } from 'react-router-dom';

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <div className="logo">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.5 5C14.5 8 10 15 8 20C12 15 18 12 23 12C18 15 14 20 12 25C16 20 22 17 27 17C22 20 18 25 16 30C20 25 26 22 31 22C26 25 22 30 20 35C24 30 30 27 35 27" stroke="white" strokeWidth="2" fill="none" />
                            </svg>
                            <div className="brand-text">
                                <h2>lsqstays</h2>
                            </div>
                        </div>
                        <p className="tagline">Luxury Redefined, Memories Created. Experience exceptional stays across Maharashtra & Pattaya, Thailand.</p>

                        <div className="contact-info">
                            <div className="contact-item">
                                <i className="fas fa-phone-alt"></i>
                                <span>+91 89288 36738</span>
                            </div>
                            <div className="contact-item">
                                <i className="fas fa-envelope"></i>
                                <span>info@lsqstays.com</span>
                            </div>
                        </div>
                    </div>

                    <div className="footer-links">
                        <div className="link-column">
                            <h3>Page</h3>
                            <ul>
                                <li><Link to="/properties" onClick={scrollToTop}>Explore Properties</Link></li>
                                <li><Link to="/about" onClick={scrollToTop}>About us</Link></li>
                                <li><Link to="/contact" onClick={scrollToTop}>Contact us</Link></li>
                                <li><Link to="/policy" onClick={scrollToTop}>Payment & Cancellation policy</Link></li>
                            </ul>
                        </div>

                        <div className="link-column">
                            <h3>Explore</h3>
                            <ul>
                                <li><Link to="/properties?location=Karjat" onClick={scrollToTop}>Karjat</Link></li>
                                <li><Link to="/properties?location=lonavala" onClick={scrollToTop}>Lonavala</Link></li>
                                <li><Link to="/properties?location=Mahabaleshwar" onClick={scrollToTop}>Mahableshwar</Link></li>
                                <li><Link to="/properties?location=Khopoli" onClick={scrollToTop}>Khopoli</Link></li>
                            </ul>
                        </div>

                        <div className="link-column">
                            <h3>More</h3>
                            <ul>
                                <li><Link to="/properties?location=Pattaya%2C+Thailand" onClick={scrollToTop}>Pattaya Thailand</Link></li>
                            </ul>
                        </div>

                        <div className="social-section">
                            <h3>Follow us on</h3>
                            <div className="social-icons">
                                <a href="https://www.airbnb.com" target="_blank" rel="noopener noreferrer" className="social-icon airbnb">
                                    <i className="fab fa-airbnb"></i>
                                </a>
                                <a href="https://www.instagram.com/lsqstays/" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                                    <i className="fab fa-instagram"></i>
                                </a>
                                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="payment-social">
                    <div className="payment-section">
                        <h3>Payment & Security</h3>
                        <div className="payment-icons">
                            <div className="payment-icon">PCI DSS</div>
                            <div className="payment-icon">MasterCard SecureCode</div>
                            <div className="payment-icon">Net Banking</div>
                            <div className="payment-icon">UPI</div>
                            <div className="payment-icon">RuPay</div>
                            <div className="payment-icon">Wallets</div>
                            <div className="payment-icon">Verified by VISA</div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="copyright">
                        <p>Copyrights ©2025 lsqstays. All rights reserved.</p>
                        {/* <p style={{ marginTop: '5px', marginBottom: '0' }}>
                            Website designed and made by <a 
                                href="https://github.com/Official-Wasim" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ color: '#20B2AA', textDecoration: 'underline', fontWeight: 'bold' }}
                            >Wasim</a>
                        </p> */}
                    </div>
                    <div className="footer-policies">
                        {/* <Link to="/privacy" onClick={scrollToTop}>Privacy policy</Link> */}
                        <Link to="/terms" onClick={scrollToTop}>Terms & conditions</Link>
                        <Link to="/policy" onClick={scrollToTop}>Payment & Cancellation policy</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;